import useBoolean from '@eduzz/houston-hooks/useBoolean';
import Button from '@eduzz/houston-ui/Button';
import Showcase from '@eduzz/houston-ui/Showcase';
import React, { memo, useCallback, useEffect } from 'react';
import { useObservable } from 'react-use-observable';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import { fidcService } from 'v2/services/fidc';

import { useStyles } from './styles';

const ModalFidc = memo(() => {
  const classes = useStyles();

  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  const [open, toggle] = useBoolean(false);

  const validateUser = useCallback(async () => {
    if (!user) return null;

    try {
      const result = await fidcService.validateCustomerReject(user.id);
      if (result?.data && !Array.isArray(result?.data)) toggle();
    } catch (err) {}
  }, [toggle, user]);

  useEffect(() => {
    validateUser();
  }, [validateUser]);

  return (
    <Showcase open={open} currentStep={1} controlDots={false}>
      <Showcase.Content>
        <Showcase.Step key='title'>
          <Showcase.Title>Comunicado importante para você!</Showcase.Title>
          <Showcase.Text>
            <p className={classes.paragraph}>
              Notamos que há <b>irregularidades</b> em seu cadastro e para que você continue vendendo com a Eduzz é necessário realizar a{' '}
              <b>regularização do seu CPF e/ou CNPJ junto a Receita Federal.</b>
            </p>
            <p className={classes.paragraph}>
              Para que possamos continuar nossa parceria juntos, pedimos que <b>até dezembro</b> deste ano você regularize seus dados cadastrais com a
              Receita Federal, para evitar qualquer tipo de problema. Combinado?
            </p>
            <br />
            <p className={classes.paragraph}>
              Conte sempre com a gente.
              <br />
              <br />
              Eduzz.
            </p>
          </Showcase.Text>
        </Showcase.Step>
      </Showcase.Content>
      <Showcase.Footer>
        <div className={classes.footer}>
          <Button onClick={toggle}>Entendi</Button>
        </div>
      </Showcase.Footer>
    </Showcase>
  );
});

export default ModalFidc;
